import { List } from '@kerfjs/ui/list';
import { ListItem } from '@kerfjs/ui/list-item';
import { LucideIcon } from '@kerfjs/ui/lucide-icon';
import type { PopupMenuEntry } from '@kerfjs/ui/popup-menu';
import { Text } from '@kerfjs/ui/text';
import type { SafeHtml } from 'kerfjs';
import { Archive, ArchiveRestore } from 'lucide';

import type { ConversationSummaryT } from '../../../data/api.js';
import { chatSortField } from '../../../data/state.js';

/** Entries of a chat row's context menu, opened at the pointer by right-click (HS2-3KAZPW). */
export function chatRowMenuEntries(chatId: string, closed: boolean): PopupMenuEntry[] {
  return [
    closed
      ? {
          label: 'Reopen Chat',
          action: 'reopen-project-chat',
          icon: <LucideIcon icon={ArchiveRestore} name="" />,
          attributes: { 'data-item-id': chatId },
        }
      : {
          label: 'Close Chat',
          action: 'close-project-chat',
          icon: <LucideIcon icon={Archive} name="" />,
          attributes: { 'data-item-id': chatId },
        },
  ];
}

export function ChatSidebarRow({
  conversation,
  closed,
  selectedId,
}: {
  conversation: ConversationSummaryT;
  closed: boolean;
  selectedId: string | null;
}): SafeHtml {
  const title = conversation.title ?? 'Untitled chat';
  return (
    <div
      class="chat-sidebar-row"
      data-key={conversation.id}
      data-context-chat={conversation.id}
      data-context-closed={closed ? '' : undefined}
    >
      <List>
        <ListItem
          label={title}
          description={conversation.scope === 'organization' ? 'Organization' : (conversation.projectName ?? 'Project')}
          action="open-thread-nav"
          itemId={conversation.id}
          selected={conversation.id === selectedId}
          multiline={true}
          trailing={
            <Text variant="span" tone="quiet" size="compact">
              {new Date(
                chatSortField.value === 'created' ? conversation.createdAt : conversation.updatedAt,
              ).toLocaleDateString()}
            </Text>
          }
        />
      </List>
    </div>
  );
}
